export default __webpack_public_path__ + "static/media/Aleo-Bold.826787e5.otf";